export type Radar = {
  notes: number;
  chord: number;
  peak: number;
  charge: number;
  scratch: number;
  soflan: number;
};

export const RADAR_ELEMENT = {
  NOTES: 1,
  CHORD: 2,
  PEAK: 3,
  CHARGE: 4,
  SCRATCH: 5,
  SOFLAN: 6,
} as const;

export type RadarElement = (typeof RADAR_ELEMENT)[keyof typeof RADAR_ELEMENT];

export const isRadarElement = (n: unknown): n is RadarElement => {
  return typeof n === "number" && Object.values<typeof n>(RADAR_ELEMENT).includes(n);
};

export type RadarElementKey = (typeof RADAR_ELEMENT_KEY)[keyof typeof RADAR_ELEMENT_KEY];

export type RadarElementString = (typeof RADAR_ELEMENT_STRING)[keyof typeof RADAR_ELEMENT_STRING];

export const RADAR_ELEMENT_KEY = {
  1: "notes",
  2: "chord",
  3: "peak",
  4: "charge",
  5: "scratch",
  6: "soflan",
} as const;

export const RADAR_ELEMENT_VALUE = {
  notes: RADAR_ELEMENT.NOTES,
  chord: RADAR_ELEMENT.CHORD,
  peak: RADAR_ELEMENT.PEAK,
  charge: RADAR_ELEMENT.CHARGE,
  scratch: RADAR_ELEMENT.SCRATCH,
  soflan: RADAR_ELEMENT.SOFLAN,
} as const;

export const RADAR_ELEMENT_STRING = {
  1: "NOTES",
  2: "CHORD",
  3: "PEAK",
  4: "CHARGE",
  5: "SCRATCH",
  6: "SOF-LAN",
} as const;

export const RADAR_ELEMENT_COLOR = {
  1: "#FF40EB",
  2: "#85E100",
  3: "#FF6C00",
  4: "#8957DD",
  5: "#DD0000",
  6: "#0086E5",
} as const;

export const RADAR_ORDER = [
  RADAR_ELEMENT.NOTES,
  RADAR_ELEMENT.CHORD,
  RADAR_ELEMENT.PEAK,
  RADAR_ELEMENT.CHARGE,
  RADAR_ELEMENT.SCRATCH,
  RADAR_ELEMENT.SOFLAN,
] as const;

export const RADAR_CLOCKWISE_ORDER = [
  RADAR_ELEMENT.NOTES,
  RADAR_ELEMENT.PEAK,
  RADAR_ELEMENT.SCRATCH,
  RADAR_ELEMENT.SOFLAN,
  RADAR_ELEMENT.CHARGE,
  RADAR_ELEMENT.CHORD,
] as const;

export const valueFloor = (value: number) => {
  const str = value.toString();
  const [int, dec = ""] = str.split(".");
  const truncated = `${int}.${dec.slice(0, 2)}`;
  return parseFloat(truncated);
};

const format = new Intl.NumberFormat("ja", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: false,
});

export const valueFormat = (value: number) => format.format(valueFloor(value));
